import { render, staticRenderFns } from "./HotelModal.vue?vue&type=template&id=096664b7"
import script from "./HotelModal.vue?vue&type=script&lang=js"
export * from "./HotelModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports